import SelectPicker from "rsuite/SelectPicker";
import 'rsuite/SelectPicker/styles/index.css';
import { DatePicker, CustomProvider } from "rsuite";
import 'rsuite/DatePicker/styles/index.css';
import * as locales from 'rsuite/locales';
import {useEffect, useState, useRef} from "react";
import { isBefore } from "date-fns";
import { axiosInstance } from "../helpers/axiosInstance";
import TitleTooltip from "../helpers/TitleTooltip";

export function InicioProyectado({
    setFieldValue,
    defaultV,
    edit
 }){
    const inicioRef = useRef(null);

    return(
        <>
            <style type={'text/css'}>
                {`
                    .inicio_proyectado > div{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #inicio_proyectado{
                        padding-top: 1.75rem!important;
                        display: block!important;
                        background-color: transparent!important;
                        text-transform: uppercase!important;
                    }
                    
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                `}
            </style>
            <div className={"position-relative"} ref={inicioRef}>
                <CustomProvider locale={locales.esES}>
                    <DatePicker
                        container={() => inicioRef.current}
                        style={{width : '100%' }}
                       // menuStyle={{width:'100%'}}
                        className={'inicio_proyectado'}
                        label={<div className={'labelSelect ps-4 pb-4'}>Inicio:</div>}
                        oneTap={true}
                        cleanable={false}
                        format={'MMM dd, yyyy'}
                        name={"inicio_proyectado"}
                        id={"inicio_proyectado"}
                        value={defaultV}
                        disabled={!edit}
                        shouldDisableDate={date => isBefore(date, defaultV)}
                        onChange={value => setFieldValue('inicio_proyectado', value)}>
                    </DatePicker>
                </CustomProvider>
            </div>
        </>
    );
}


export function FinProyectado({
     setFieldValue,
     defaultV,
     disableValue,
     edit
 }){
    const finRef = useRef(null);
    return(
   <>
       <style type={'text/css'}>
           {`
                    .termino_proyectado > div{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #termino_proyectado{
                        padding-top: 1.75rem!important;
                        display: block!important;
                        background-color: transparent!important;
                        text-transform: uppercase!important;
                    }
                    
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                `}
       </style>
       <div className={"position-relative"} ref={finRef}></div>
       <CustomProvider locale={locales.esES}>
           <DatePicker
               container={() => finRef.current}
               style={{width : "100%" }}
               menuStyle={{width : "auto"}}
               label={<div className={'labelSelect ps-4 pb-4'}>Fin:</div>}
               className={'termino_proyectado'}
               oneTap={true}
               cleanable={false}
               format={'MMM dd, yyyy'}
               name={"termino_proyectado"}
               id={"termino_proyectado"}
               value={defaultV}
               disabled={!edit}
               shouldDisableDate={date => isBefore(date, new Date(disableValue))}
               onChange={value => setFieldValue('termino_proyectado', value)}>
           </DatePicker>
       </CustomProvider>
   </>
    );
}

export function Recordatorio({
     setFieldValue,
     defaultV,
     disableValue,
     edit
 }){
    const recordatorioRef = useRef(null);
    return(
        <>
            <style type={'text/css'}>
                {`
                    .recordatorio > div{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #recordatorio{
                        padding-top: 1.75rem!important;
                        display: block!important;
                        background-color: transparent!important;
                        text-transform: uppercase!important;
                    }
                    
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                `}
            </style>
            <div className={'position-relative'} ref={recordatorioRef}>
                <CustomProvider locale={locales.esES}>
                    <DatePicker
                        container={() => recordatorioRef.current}
                        style={{width : "100%" }}
                        //menuStyle={{width : "auto"}}
                        className={'recordatorio'}
                        label={<div className={'labelSelect ps-4 pb-4'}>Recordatorio:</div>}
                        oneTap={true}
                        cleanable={false}
                        //placement={'auto'}
                        format={'MMM dd, yyyy'}
                        name={"recordatorio"}
                        id={"recordatorio"}
                        value={defaultV}
                        disabled={!edit}
                        shouldDisableDate={date => isBefore(date, new Date(disableValue))}
                        onChange={value => setFieldValue('recordatorio', value)}>
                    </DatePicker>
                </CustomProvider>
            </div>
        </>
    );
}

export function Roles({
    setFieldValue,
    values,
}){
    const [rol, setRol] = useState([]);
    const rolRef = useRef(null);

     useEffect(() => {
        const rolesLS = JSON.parse(localStorage.getItem('roles'));
        setRol(rolesLS);
     }, []);


    const rolMap = rol.map(
        item => ({ label: item.descripcion, value: item.descripcion})
    );

    if (rol.length > 0) {
        return(
            <>
                <style type={'text/css'}>
                    {`
                    #rol{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #rol > .rs-stack{
                        display : block!important;
                    }
                    #rol-label{
                        display : flex!important;
                    }
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    #rol > .rs-stack > div:nth-child(2){
                        padding-top : 1.25rem;
                        text-transform:uppercase!important;
                    }
                    
                    #rol-listbox > div > span.rs-picker-select-menu-item-active{
                        color : var(--bs-component-hover-color);
                    }
                    
                    #rol-listbox > div > span.rs-picker-select-menu-item-active::after{
                        background-color: var(--bs-component-hover-color);
                        content: "";
                        display: block;
                        height: .75rem;
                        -webkit-mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-position: center;
                        -webkit-mask-position: center;
                        mask-repeat: no-repeat;
                        -webkit-mask-repeat: no-repeat;
                        width: .75rem;
                    }
                    
                    #rol-listbox > div > span.rs-picker-select-menu-item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        text-transform:uppercase!important;
                    }
                    .rs-picker-toggle-label::after {
                        display : none!important;
                    }
                    
                `}
                </style>
                <div ref={rolRef} className={'position-relative'}>
                    <SelectPicker
                        container={() => rolRef.current}
                        style={{width : "100%" }}
                        menuStyle={{width : "auto"}}
                        label={<div className={'labelSelect ps-3 pb-4'}>Rol:</div>}
                        searchable={false}
                        data={rolMap}
                        cleanable={false}
                        name={'rol'}
                        id={'rol'}
                        value={values.rol}
                        onChange={(value) => setFieldValue('rol', value) }
                        // renderValue={(value, item) => {
                        //     return(
                        //         <div style={{paddingTop: '0.38rem', paddingBottom: '0.38rem'}}>{item.label}</div>
                        //     )
                        // }}
                    >
                    </SelectPicker>
                </div>
            </>
        );
    }
}

export function Usuarios({
    setFieldValue,
    values,
    disableOpc
}) {
    const containerRef = useRef();

    const [miembros, setMiembros] = useState([]);

    useEffect(() => {
        const miembrosLS = JSON.parse(localStorage.getItem('miembros'));
        if (miembrosLS && miembrosLS.length > 0) {
            setMiembros(miembrosLS);
        } else {
            axiosInstance.get('todo/tareas/usuarios')
                .then((res) => {
                    setMiembros(res.data.usuarios);
                    localStorage.setItem('miembros', JSON.stringify(res.data.usuarios));
                })
        }
    }, []);

    const dataM = miembros.map(
        item => ({label: item.usuario, value: item.id_usuario, avatar: item.avatar, usuario: item.usuario})
    );

    const noOpc = disableOpc && disableOpc.length > 0 ? disableOpc.map((o) => (o.id_usuario || o.usuario.id_usuario)) : [];


    if (dataM.length > 0) {
        return (
            <>
                <style type={'text/css'}>
                    {`
                    #id_usuario{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #id_usuario > .rs-stack{
                        display : block!important;
                    }
                    #id_usuario-label{
                        display : flex!important;
                    }
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    #id_usuario > .rs-stack > div:nth-child(2){
                        padding-top : 1.25rem;
                        text-transform:uppercase!important;
                    }
                    
                    #id_usuario-listbox > div > span.rs-picker-select-menu-item-active{
                        color : var(--bs-component-hover-color);
                    }
                    
                    #id_usuario-listbox > div > span.rs-picker-select-menu-item-active::after{
                        background-color: var(--bs-component-hover-color);
                        content: "";
                        display: block;
                        height: .75rem;
                        -webkit-mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-position: center;
                        -webkit-mask-position: center;
                        mask-repeat: no-repeat;
                        -webkit-mask-repeat: no-repeat;
                        width: .75rem;
                    }
                    
                    #id_usuario-listbox > div > span.rs-picker-select-menu-item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        text-transform:uppercase!important;
                    }
                    .rs-picker-toggle-label::after {
                        display : none!important;
                    }
                    
                `}
                </style>
                <div ref={containerRef} style={{position: 'relative'}}>
                    <SelectPicker
                        container={() => containerRef.current}
                        style={{width : "100%" }}
                        menuStyle={{width : "auto"}}
                        label={<div className={'labelSelect ps-2 pb-4'}>Usuario:</div>}
                        value={values}
                        name={'id_usuario'}
                        id={'id_usuario'}
                        data={dataM}
                        labelKey={"label"}
                        cleanable={false}
                        valueKey={"value"}
                        disabledItemValues={noOpc}
                        onChange={(value) => setFieldValue('id_usuario', value)}
                        renderMenuItem={renderMenuItem}
                        renderValue={renderValue}
                    />
                </div>
            </>
        );
    }
}

const renderMenuItem = (label, item) => {
    return (
        <div className="d-flex align-items-center">
            <div className="symbol symbol-20px me-3">
                <span className={"symbol-label fs-8 " + item.avatar}>{item.avatar}</span>
            </div>
            <div className="d-flex flex-column">
                <span className="fs-6 fw-bold lh-1 text-capitalize">{label}</span>
            </div>
        </div>
    );
}


const renderValue = (value, item) => {
    return (
        <div className="d-flex align-items-center">
            <div className="symbol symbol-20px me-3">
                <span className={"symbol-label fs-8 " + item.avatar}>{item.avatar}</span>
            </div>
            <div className="d-flex flex-column">
                <span
                    className="fs-6 fw-bold lh-1 text-capitalize">{item.label}
                </span>
            </div>
        </div>
    );
}

export function PrioridadIcon({classB}) {
    switch (classB) {
        case "A":
            return <TitleTooltip title={"Prioridad alta"} placement={'top'}>
                <span className={"bullet bullet-vertical h-40px bg-info"}></span>
            </TitleTooltip>;
        case "MA":
            return <TitleTooltip title={"Prioridad muy alta"} placement={'top'}>
                <span className={"bullet bullet-vertical h-40px bg-danger"}></span>
            </TitleTooltip>;
        case "B":
            return <TitleTooltip title={"Prioridad baja"} placement={'top'}>
                <span className={"bullet bullet-vertical h-40px bg-success"}></span>
            </TitleTooltip>;
        case "MB":
            return <TitleTooltip title={"Prioridad muy baja"} placement={'top'}>
                <span className={"bullet bullet-vertical h-40px bg-primary"}></span>
            </TitleTooltip>;
        default:
            return <TitleTooltip title={"Prioridad normal"} placement={'top'}>
                <span className={"bullet bullet-vertical h-40px bg-warning"}></span>
            </TitleTooltip>;
    }
}
